<template>
  <div :style="fieldStyle">
    <label
      v-if="label"
      :for="id"
      ref="label"
      :style="labelStyle"
      class="font-medium text-grey-30"
    >
      {{ label }}
      <span
        v-if="optional && !disabled"
        class="text-xs font-lighter italic"
      >
        <slot name="optional">
          {{ $t('common.formFields.fields.optional') }}
        </slot>
      </span>

      <slot name="hint" />
    </label>

    <VSelect
      ref="vue-select"
      class="multiselect-custom-style"
      v-bind="$attrs"
      :value="value"
      :id="eSelectId"
      :label="eSelectLabel"
      :disabled="disabled"
      :placeholder="ePlaceholder"
      :trackBy="trackBy"
      v-on="listeners"
      @input="input"
    />

    <slot name="extra" />
  </div>
</template>

<script>
import _ from 'lodash'

import VSelect from 'vue-multiselect'

export default {
  components: { VSelect },

  inheritAttrs: false,

  props: {
    eSelectId: {
      type: [Number, String]
    },
    eSelectLabel: {
      type: String,
      default: ''
    },
    ePlaceholder: {
      type: String,
      default: ''
    },
    trackBy: {
      type: String
    },
    id: {
      type: [Number, String]
    },
    value: {
      type: [Object, Array, String, Number]
    },
    label: {
      type: String
    },
    optional: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    fieldStyle: {
      type: [Object, String]
    },
    labelStyle: {
      type: [Object, String]
    },
    inputErrorStyle: {
      type: [Object, String]
    },
    invalid: {
      type: Boolean,
      default: false
    }
  },

  watch: {
    invalid: function (isInvalid) {
      let elm = this.$refs['vue-select'].$vnode.elm.querySelectorAll('.multiselect__tags')[0]

      _.forEach(this.inputErrorStyle, (value, key) => {
        elm.style[key] = isInvalid ? value : ''
      })
    }
  },

  computed: {
    listeners () {
      const { input, ...listeners } = this.$listeners

      return listeners
    }
  },

  methods: {
    input (event) {
      this.$emit('input', event)
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
.multiselect-custom-style .multiselect__tags {
  overflow: hidden;

  @apply border border-solid border-grey-80 pl-4 pt-2 pr-10;

  min-height: 38px;
}

.multiselect-custom-style .multiselect__placeholder {
  @apply pt-0;

  font-size: 16px;
  font-weight: 400;
  line-height: 1.15;
  letter-spacing: normal;
  margin-bottom: 8px;
}

.multiselect-custom-style .multiselect__input[placeholder] {
  &[placehalder] {
    font-size: 16px;
    font-weight: 400;
    line-height: 1.15;
    color: #adadad;
    letter-spacing: normal;
  }

  transition: unset;
}

.multiselect-custom-style .multiselect__input,
.multiselect-custom-style .multiselect__single {
  @apply p-0;
}

.multiselect-custom-style .multiselect__tag {
  @apply mx-1 mt-1 mb-0;
}

.multiselect-custom-style .multiselect__tags-wrap {
  @apply -m-1 inline-block;

  max-width: 100%;
  line-height: 1.15;
}

.multiselect-custom-style.multiselect--active .multiselect__input {
  width: auto !important;
}

.multiselect-custom-style.multiselect--active .multiselect__tags {
  @apply shadow-outline-info border-info-50;
}

.multiselect-custom-style .multiselect__option--highlight,
.multiselect-custom-style .multiselect__option--highlight::after,
.multiselect-custom-style .multiselect__tag {
  @apply bg-grey-95 text-grey-40;
}

.multiselect-custom-style .multiselect__option {
  @apply text-grey-40;
  @apply truncate;
}

.multiselect-custom-style .multiselect__tag-icon:hover {
  @apply bg-grey-30;
}

.multiselect-custom-style .multiselect__content {
  max-width: 100%;
}

.multiselect-custom-style .multiselect__option--selected::after {
  background-color: #eef3f7;
}
</style>
